export default __webpack_public_path__ + "static/media/1.4b0a9259.svg";